import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck, getToken } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyAuezzSWSfrpnvxxxRVSI4u0lAtZpCnGpg",
  authDomain: "investor-database-c0c49.firebaseapp.com",
  projectId: "investor-database-c0c49",
  storageBucket: "investor-database-c0c49.firebasestorage.app",
  messagingSenderId: "952602799897",
  appId: "1:952602799897:web:e4e57ca14c86294cbc9f88",
  measurementId: "G-22G1K13WLX"
};

let firebaseApp: FirebaseApp;
let appCheck: AppCheck | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    firebaseApp = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
  }
  return firebaseApp;
}

export function initAppCheck(): AppCheck | null {
  if (appCheck) return appCheck;

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  if (!siteKey) {
    console.warn('App Check: REACT_APP_RECAPTCHA_SITE_KEY not set, skipping');
    return null;
  }

  try {
    // Enable debug mode in development
    if (process.env.NODE_ENV === 'development') {
      (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    const app = getFirebaseApp();
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true
    });
    console.log('App Check initialized');
    return appCheck;
  } catch (error) {
    console.error('App Check init failed:', error);
    return null;
  }
}

export async function getAppCheckToken(): Promise<string | null> {
  if (!appCheck) return null;
  try {
    const result = await getToken(appCheck, false);
    return result.token;
  } catch (error) {
    console.error('Failed to get App Check token:', error);
    return null;
  }
}
